import { FilterFormValues } from "../components/forms";
import {
  DATE_RANGE_FILTER_SEARCH_PARAMETER,
  STATUS_FILTER_SEARCH_PARAMETER,
  TOTAL_FROM_FILTER_SEARCH_PARAMETER,
  TOTAL_TO_FILTER_SEARCH_PARAMETER
} from "../constants";

export const getTransactionsTableFilterNewSearchParams = ({
  dateRange,
  transactionTotalFrom,
  transactionTotalTo,
  statuses
}: FilterFormValues) => {
  const newSearchParams: Record<string, string | string[]> = {};

  if (statuses != null)
    newSearchParams[STATUS_FILTER_SEARCH_PARAMETER] = statuses;

  if (dateRange && Array.isArray(dateRange)) {
    newSearchParams[DATE_RANGE_FILTER_SEARCH_PARAMETER] = dateRange.filter(
      (date): date is string => date !== null
    );
  } else {
    newSearchParams[DATE_RANGE_FILTER_SEARCH_PARAMETER] = [];
  }

  if (transactionTotalFrom != null)
    newSearchParams[TOTAL_FROM_FILTER_SEARCH_PARAMETER] =
      String(transactionTotalFrom);
  if (transactionTotalTo != null)
    newSearchParams[TOTAL_TO_FILTER_SEARCH_PARAMETER] =
      String(transactionTotalTo);

  return newSearchParams;
};
